/**
 * Converts an ISO 3166-1 alpha-2 code to its flag emoji (regional indicators).
 * Returns '' for a missing/blank code — a server may have no region set.
 */
export function countryFlag(countryCode: string | null | undefined): string {
  if (!countryCode) return '';

  const code = countryCode.trim().toUpperCase();

  if (!/^[A-Z]{2}$/.test(code)) return '';

  const base = 0x1f1e6;
  const a = 'A'.charCodeAt(0);

  return String.fromCodePoint(base + code.charCodeAt(0) - a, base + code.charCodeAt(1) - a);
}
